import { render } from "./GridOportunitati.vue?vue&type=template&id=9d9c34e2&scoped=true&ts=true"
import script from "./GridOportunitati.vue?vue&type=script&lang=ts"
export * from "./GridOportunitati.vue?vue&type=script&lang=ts"

import "./GridOportunitati.vue?vue&type=style&index=0&id=9d9c34e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9c34e2"]])

export default __exports__